(() => {
  "use strict";

  const initMenu = (root = document) => {
    root.querySelectorAll("[data-menu-button]").forEach((button) => {
      if (button.dataset.initialized === "true") return;
      button.dataset.initialized = "true";

      const id = button.getAttribute("aria-controls");
      const menu = document.getElementById(id);
      if (!menu) return;

      button.addEventListener("click", () => {
        const isOpen = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!isOpen));
        menu.classList.toggle("is-open", !isOpen);
      });
    });
  };

  const initProduct = (root = document) => {
    root.querySelectorAll("[data-product-section]").forEach((section) => {
      if (section.dataset.initialized === "true") return;
      section.dataset.initialized = "true";

      const select = section.querySelector("[data-variant-select]");
      const price = section.querySelector("[data-price]");
      const compare = section.querySelector("[data-compare-price]");
      const submit = section.querySelector("[data-add-button]");
      const submitText = section.querySelector("[data-add-button-text]");
      const form = section.querySelector("[data-product-form]");
      const sticky = section.querySelector("[data-sticky-atc]");
      const stickyButton = section.querySelector("[data-sticky-button]");
      const stickyPrice = section.querySelector("[data-sticky-price]");

      const update = () => {
        if (!select) return;
        const option = select.options[select.selectedIndex];
        if (!option) return;

        const available = option.dataset.available === "true";
        const currentPrice = option.dataset.price || "";
        const currentCompare = option.dataset.compare || "";

        if (price) price.textContent = currentPrice;
        if (stickyPrice) stickyPrice.textContent = currentPrice;
        if (compare) {
          compare.textContent = currentCompare;
          compare.hidden = !currentCompare || currentCompare === currentPrice;
        }
        if (submit) submit.disabled = !available;
        if (stickyButton) stickyButton.disabled = !available;

        if (submitText) {
          submitText.textContent = available
            ? submitText.dataset.availableText
            : submitText.dataset.soldOutText;
        }

        if (option.dataset.url && window.history?.replaceState) {
          window.history.replaceState({}, "", option.dataset.url);
        }
      };

      select?.addEventListener("change", update);
      update();

      stickyButton?.addEventListener("click", () => {
        if (!form || stickyButton.disabled) return;
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else submit?.click();
      });

      if (sticky && submit && "IntersectionObserver" in window) {
        const observer = new IntersectionObserver(([entry]) => {
          sticky.classList.toggle("is-visible", !entry.isIntersecting);
        }, { threshold: .15 });
        observer.observe(submit);
      }
    });
  };

  const init = (root = document) => {
    initMenu(root);
    initProduct(root);
  };

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
